export default "/images/vendor/flag-icon-css/flags/4x3/rw.svg?fbb7d374d6bc26a0991d624933c89633";